import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import Radio from '@material-ui/core/Radio';

const DefaultRadio = withStyles({
  root: {
    color: '#585858',
    '&$checked': {
      color: '#3DB5E6',
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

export default DefaultRadio;
